module.exports = __webpack_public_path__ + "img/thumbnail_SaltwaterCrocodile_f_albino.a1a75a2b.png";